import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
// import DarkModeBtn from '../components/DarkModeBtn';
import { useUser } from '../contexts/UserContext';
import LogoutButton from '../components/LogoutButton';
import UserActionsBar from '../components/UserActionsBar';
const Support = () => {
   // const { userEmail, userName } = useUser();
   const { userEmail } = useUser();
   const [openFaq, setOpenFaq] = useState(null); // Estado para controlar cuál FAQ está abierto
   // Función para manejar el clic en un ítem del acordeón
   const toggleFaq = (index) => {
      setOpenFaq(openFaq === index ? null : index);
   };
   // Datos de FAQ
   const faqItems = [
      {
         question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit?",
         answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip."
      },
      {
         question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit?",
         answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip."
      },
      {
         question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit?",
         answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip."
      }
   ];
   return (
      <div className="container-fluid max py-lg-5" page-key="Dashboard">
         {/* Cabecera común para ambas vistas */}
      <nav class="navbar navbar-expand-lg p-0 mb-4 mb-lg-5">
            <div class="container-fluid px-0">
               <div className="row align-items-center w-100 mx-0" data-orders>
                  <div data-order="1" className="col col-lg-3 px-0">
                     <NavLink to="/dashboard" className="">
                        <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
                     </NavLink>
                  </div>
                  <div data-order="2" className="col-auto d-flex align-items-center gap-3 px-0">
                     <UserActionsBar />
                     <span className="d-lg-none" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <svg width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <rect x="0.577148" width="27.4231" height="3.53846" fill="var(--white)" />
                           <rect x="0.577148" y="9.73077" width="27.4231" height="3.53846" fill="var(--white)" />
                           <rect x="0.577148" y="19.4615" width="27.4231" height="3.53846" fill="var(--white)" />
                        </svg>
                     </span>
                  </div>
                  <div data-order="3" className="collapse navbar-collapse" id="navbarNavDropdown">
                     <div className="col">
                        <nav className="ppt_navdash">
                           <NavLink to="/dashboard" className="link">Wallet</NavLink>
                           <NavLink to="/propt-tokens" className="link">Propt Tokens</NavLink>
                           {/* <span className="link">Earn</span> */}
                           <NavLink to="/support" className="link">SUPPORT</NavLink>
                           <NavLink to="/settings" className="link d-lg-none">SETTINGS</NavLink>
                           <span className="link d-lg-none">
                              <LogoutButton />
                           </span>
                        </nav>
                     </div>
                  </div>
               </div>
            </div>
         </nav>
         <div className="row mb-5">
            <div className="col mb-4">
               <div className="ppt_box_gen h-100 p-4">
                  <h3 className="ppt_form_title mb-4 px-lg-3 w-100">Contact Us</h3>
                  <form className="ppt_form">
                     <div className="row mb-3">
                        <div className="col-12 col-lg mb-3 mb-lg-0">
                           <div className="ppt_input_style">
                              <label htmlFor="firstName">First Name</label>
                              <div>
                                 <input
                                    type="text"
                                    id="firstName"
                                    className="form-control"
                                    placeholder="Enter your first name"
                                 />
                              </div>
                           </div>
                        </div>
                        <div className="col-12 col-lg">
                           <div className="ppt_input_style">
                              <label htmlFor="lastName">Last Name</label>
                              <div>
                                 <input
                                    type="text"
                                    id="lastName"
                                    className="form-control"
                                    placeholder="Enter your last name"
                                 />
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="ppt_input_style mb-3">
                        <label htmlFor="email">Email</label>
                        <div>
                           <input
                              type="email"
                              id="email"
                              className="form-control"
                              placeholder="Enter your email address"
                              defaultValue={userEmail || ''}
                           />
                        </div>
                     </div>
                     <div className="ppt_input_style mb-3">
                        <label htmlFor="accountNumber">Account Number</label>
                        <div>
                           <input
                              type="text"
                              id="accountNumber"
                              className="form-control"
                              placeholder="Enter your account number"
                           />
                        </div>
                     </div>
                     <div className="ppt_input_style mb-4">
                        <label htmlFor="message">How can we help you?</label>
                        <div>
                           <textarea
                              id="message"
                              className="form-control"
                              rows="5"
                              placeholder="Describe your issue or question in detail"
                           ></textarea>
                        </div>
                     </div>
                     <div className="ppt_input_style mb-4">
                        <button
                           type="submit"
                           className="ppt_btn_primary alt"
                           onClick={(e) => {
                              e.preventDefault();
                              alert('Your message has been sent. We will get back to you soon.');
                           }}
                        >
                           SEND
                        </button>
                     </div>
                  </form>
               </div>
            </div>
            <div className="col mb-4">
               <div className="ppt_box_gen h-100">
                  <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center py-4 px-lg-4">
                     <div className="mb-3">
                        <img src={process.env.PUBLIC_URL + '/assets/img/icon_chat.svg'} data-lightmodeimg alt="Contact" className="mb-4" style={{ width: '100px' }} />
                        <h3 className="">Get in touch with us</h3>
                     </div>
                     <div className="d-flex flex-column gap-2 align-items-start text-start w-100 ppt_contact_info_details">
                        <div className="d-flex gap-3 align-items-start">
                           <img src={process.env.PUBLIC_URL + '/assets/img/icon_phone.svg'} alt="Phone" className="" style={{ width: '24px' }} />
                           <div>
                              <span>Phone number: </span>
                              <a href="tel:+14702073877" className="text-decoration-underline">+1 (470) 207-3877</a>
                           </div>
                        </div>
                        <div className="d-flex gap-3 align-items-start">
                           <img src={process.env.PUBLIC_URL + '/assets/img/icon_mail.svg'} alt="Email" className="mt-1" style={{ width: '24px' }} />
                           <div>
                              <span>Email: </span>
                              <a href="mailto:support@getpropert.com" className="text-decoration-underline">support@getpropert.com</a>
                           </div>
                        </div>
                        <div className="d-flex gap-3 align-items-start">
                           <img src={process.env.PUBLIC_URL + '/assets/img/icon_location.svg'} alt="Address" className="mt-1" style={{ width: '24px' }} />
                           <div>
                              <span>Address: </span>
                              <span>ProperT LLC · PO Box 25437</span>
                              <br />
                              <span className="ps-5">Christiansted, VI 00824</span>
                           </div>
                        </div>
                     </div>
                     <button className="ppt_btn_primary alt mt-5 d-flex align-items-center gap-2">
                        <img src={process.env.PUBLIC_URL + '/assets/img/icon_chat_alt.svg'} alt="Chat" style={{ width: '20px' }} />
                        Chatbot
                     </button>
                  </div>
               </div>
            </div>
            <div className="col-12">
               <div className="ppt_box_gen h-100 p-4">
                  <h3 className="ppt_form_title px-lg-3 w-100">FAQ</h3>
                  <div className="ppt_faqs">
                     {faqItems.map((item, index) => (
                        <div
                           className="ppt_faqs_item"
                           key={index}
                        >
                           <span
                              className="ppt_faqs_item_title"
                              onClick={() => toggleFaq(index)}
                           // style={{
                           //    color: openFaq === index ? '#e4dc00' : 'inherit'
                           // }}
                           >
                              {item.question}
                              <i
                                 className="faq-arrow"
                                 style={{
                                    transform: openFaq === index ? 'rotate(135deg)' : 'rotate(-45deg)',
                                    transition: 'transform 0.3s ease',
                                    minWidth: '14px',
                                    height: '14px',
                                    border: '3px solid #fff',
                                    display: 'block',
                                    borderRight: '0',
                                    borderTop: '0',
                                    marginLeft: '10px',
                                    borderColor: openFaq === index ? '#e4dc00' : 'inherit'
                                 }}
                              />
                           </span>
                           {openFaq === index && (
                              <div className="ppt_faqs_item_content">
                                 <p>{item.answer}</p>
                              </div>
                           )}
                        </div>
                     ))}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};
export default Support;